import { GlTooltipDirective, GlIcon, GlLink, GlButton } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __, sprintf } from '~/locale';
import { InternalEvents } from '../../tracking/index.js?vue3';
import { HISTORY_BUTTON_CLICK } from '~/tracking/constants';
import SafeHtml from '~/vue_shared/directives/safe_html';
import defaultAvatarUrl from 'images/no_avatar.png';
import TimeagoTooltip from '../../vue_shared/components/time_ago_tooltip.vue?vue3';
import UserAvatarLink from '../../vue_shared/components/user_avatar/user_avatar_link.vue?vue3';
import UserAvatarImage from '../../vue_shared/components/user_avatar/user_avatar_image.vue?vue3';
import getRefMixin from '../mixins/get_ref';
const trackingMixin = InternalEvents.mixin();
export default {
    name: 'CollapsibleCommitInfo',
    components: {
        UserAvatarLink,
        TimeagoTooltip,
        GlIcon,
        GlButton,
        GlLink,
        UserAvatarImage
    },
    directives: {
        GlTooltip: GlTooltipDirective,
        SafeHtml
    },
    mixins: [
        getRefMixin,
        trackingMixin
    ],
    props: {
        commit: {
            type: Object,
            required: true
        },
        historyUrl: {
            type: String,
            required: false,
            default: ''
        }
    },
    data () {
        return {
            showDescription: false
        };
    },
    computed: {
        commitDescription () {
            // Strip the newline at the beginning
            return this.commit?.descriptionHtml?.replace(/^&#x000A;/, '');
        },
        avatarLinkAltText () {
            return sprintf(__(`%{username}'s avatar`), {
                username: this.commit.authorName
            });
        },
        commitId () {
            return this.commit?.sha?.substr(0, 8);
        }
    },
    methods: {
        toggleShowDescription () {
            this.showDescription = !this.showDescription;
        },
        handleHistoryClick () {
            this.trackEvent(HISTORY_BUTTON_CLICK);
        }
    },
    defaultAvatarUrl,
    safeHtmlConfig: {
        ADD_TAGS: [
            'gl-emoji'
        ]
    },
    i18n: {
        toggleCommitDescription: __('Toggle commit description'),
        authored: __('authored')
    }
};
